// Brown noise for the bridge between tracks (Voyage's brown-noise bridge), generated the way Tone.js makes
// Tone.Noise('brown'): leaky integration of white noise, scaled by 3.5.

export function makeBrownNoise(ctx: BaseAudioContext, seconds = 4): AudioBuffer {
  const n = Math.round(seconds * ctx.sampleRate);
  const buf = ctx.createBuffer(2, n, ctx.sampleRate);
  for (let c = 0; c < 2; c++) {
    const d = buf.getChannelData(c);
    let last = 0;
    for (let i = 0; i < n; i++) {
      const white = Math.random() * 2 - 1;
      last = (last + 0.02 * white) / 1.02;
      d[i] = last * 3.5;
    }
    // remove the step at the loop point: subtract a linear ramp so the last sample meets the first
    const step = d[n - 1]! - d[0]!;
    for (let i = 0; i < n; i++) d[i] = d[i]! - (step * i) / (n - 1);
  }
  return buf;
}
